import Model from '@/models/Model';
import store from '@/store';
import psl from 'psl';

export default class Message extends Model {
    get route () {
        return 'messages';
    }

    static get className () {
        return 'Message';
    }

    static replaceMessageAttachmentUrls (message, toInserve = false) {
        const parsedHost = psl.parse(window.location.host);
        if (!parsedHost.domain) {
            return message;
        }

        let toDomain = parsedHost.domain;
        let fromDomain = import.meta.env.VITE_DOMAIN || 'inserve.nl';
        const portalDomain = import.meta.env.VITE_PORTAL_DOMAIN || 'inportal.nl';

        if (toDomain !== portalDomain) {
            // Custom Portal URL
            toDomain = `${parsedHost.subdomain}.${toDomain}`;
            fromDomain = `${store.state.systemStatus.tenant}.${fromDomain}`;
        }

        if (toInserve) {
            const tempFromDomain = fromDomain;
            fromDomain = toDomain;
            toDomain = tempFromDomain;
        }

        const attachmentPath = '/api/attachments';

        return message.replaceAll(fromDomain + attachmentPath, toDomain + attachmentPath);
    }
}
